'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    navCategoryItemClassNames: function() {
        return navCategoryItemClassNames;
    },
    useNavCategoryItemStyles_unstable: function() {
        return useNavCategoryItemStyles_unstable;
    },
    useRootStyles: function() {
        return useRootStyles;
    }
});
const _react = require("@griffel/react");
const _sharedNavStylesstyles = require("../sharedNavStyles.styles");
const navCategoryItemClassNames = {
    root: 'fui-NavCategoryItem',
    icon: 'fui-NavCategoryItem__icon',
    expandIcon: 'fui-NavCategoryItem__expandIcon',
    expandIconMotion: 'fui-NavCategoryItem__expandIconMotion'
};
const useExpandIconStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        Jyy4pa: "f1lfeew",
        Bqenvij: "fjamq6b"
    },
    selected: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "f1i3iumi"
    }
}, {
    d: [
        ".f1lfeew{-webkit-margin-start:auto;margin-inline-start:auto;}",
        ".fjamq6b{height:20px;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}"
    ]
});
const useRootStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        a9b677: "fly5x3f"
    }
}, {
    d: [
        ".fly5x3f{width:100%;}"
    ]
});
const useNavCategoryItemStyles_unstable = (state)=>{
    'use no memo';
    const rootStyles = useRootStyles();
    const smallStyles = (0, _sharedNavStylesstyles.useSmallStyles)();
    const defaultRootClassName = (0, _sharedNavStylesstyles.useRootDefaultClassName)();
    const contentStyles = (0, _sharedNavStylesstyles.useContentStyles)();
    const indicatorStyles = (0, _sharedNavStylesstyles.useIndicatorStyles)();
    const iconStyles = (0, _sharedNavStylesstyles.useIconStyles)();
    const expandIconStyles = useExpandIconStyles();
    const { selected, open, density } = state;
    state.root.className = (0, _react.mergeClasses)(navCategoryItemClassNames.root, defaultRootClassName, rootStyles.base, density === 'small' && smallStyles.root, selected && open === false && indicatorStyles.base, selected && open === false && contentStyles.selected, state.root.className);
    state.expandIcon.className = (0, _react.mergeClasses)(navCategoryItemClassNames.expandIcon, expandIconStyles.base, state.expandIcon.className);
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(navCategoryItemClassNames.icon, iconStyles.base, selected && iconStyles.selected, state.icon.className);
    }
    return state;
};
